import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Button, TextField, Autocomplete } from "@mui/material";

import {
  primaryColor,
  secondaryColor,
  textFieldSx,
} from "../hooks/useFirstTimeRegister";

import { REGISTER_GUEST_REFERRAL_SOURCES } from "./register/registerFieldConfig";

export default function RegisterGuestReferralSection({
  guestReferralSource,
  setGuestReferralSource,
  guestReferralName,
  setGuestReferralName,
  onNavigateGuestBond,
  onGuestBackToSelection,
}) {
  const showReferrerName =
    guestReferralSource?.toLowerCase().includes("referred");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 1 }} data-testid="register-guest-referral">
      <Typography variant="h6" sx={{ fontWeight: 600, color: primaryColor }}>
        How did you find us?
      </Typography>
      <Autocomplete
        options={REGISTER_GUEST_REFERRAL_SOURCES}
        value={guestReferralSource || null}
        onChange={(_, newValue) => setGuestReferralSource(newValue || "")}
        renderInput={(params) => (
          <TextField {...params} placeholder="Select one..." sx={textFieldSx} inputProps={{ ...params.inputProps, 'data-testid': 'register-guestReferralSource' }} />
        )}
      />
      {showReferrerName && (
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
              Who referred you?
            </Typography>
          </Box>
          <TextField
            fullWidth
            variant="outlined"
            value={guestReferralName}
            onChange={(e) => setGuestReferralName(e.target.value)}
            placeholder="e.g. Smith Law Firm, Miami-Dade Court"
            sx={textFieldSx}
            inputProps={{ 'data-testid': 'register-guestReferralName' }}
          />
        </Box>
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 0.5 }}>
        <Button
          variant="contained"
          onClick={onNavigateGuestBond}
          data-testid="register-guest-continue"
          sx={{
            flex: 1,
            borderRadius: "0px",
            py: 1.2,
            fontSize: "1rem",
            fontWeight: 600,
            bgcolor: primaryColor,
            color: "white",
            boxShadow: "0 8px 32px rgba(51, 51, 51, 0.3)",
            "&:hover": {
              bgcolor: secondaryColor,
              boxShadow: "0 12px 40px rgba(51, 51, 51, 0.4)",
              transform: "translateY(-1px)",
            },
            textTransform: "none",
            transition: "all 0.3s ease",
          }}
        >
          Continue to Bond Request
        </Button>
        <Button
          variant="outlined"
          onClick={onGuestBackToSelection}
          sx={{
            flex: 1,
            borderRadius: "0px",
            py: 1.2,
            fontSize: "1rem",
            fontWeight: 600,
            borderColor: primaryColor,
            color: primaryColor,
            borderWidth: "2px",
            "&:hover": {
              borderColor: secondaryColor,
              backgroundColor: "rgba(51, 51, 51, 0.08)",
              borderWidth: "2px",
              transform: "translateY(-1px)",
            },
            textTransform: "none",
            transition: "all 0.3s ease",
          }}
        >
          Back to Selection
        </Button>
      </Box>
    </Box>
  );
}

RegisterGuestReferralSection.propTypes = {
  guestReferralSource: PropTypes.string,
  setGuestReferralSource: PropTypes.func.isRequired,
  guestReferralName: PropTypes.string,
  setGuestReferralName: PropTypes.func.isRequired,
  onNavigateGuestBond: PropTypes.func.isRequired,
  onGuestBackToSelection: PropTypes.func.isRequired,
};
